import en from './strings.en';

const ru = {
    recommendations: 'Рекомендаций: {{count}}',
    recommendationAbbr: 'р',
    claims: 'Претензий: {{count}}',
    claimsAbbr: 'п',
    badPartners: 'Упоминаний на форуме "Недобросовестные партнёры": {{count}} от {{firmCount}} {{string}}',
    badPartnersAbbr: 'нп',
    oneFirm: 'фирмы',
    twoFirms: 'фирм',
    manyFirms: 'фирм',
    otherFirms: 'фирм',
};

export default { ru, en: { ...ru, ...en} };
